<template>
	<div class="c-gray ovf-hd m-w-1280">
    <div class="design-left-layout" v-loading="loading">
      <div class="content-scroll">
        <div>
          <el-button @click="goBack()">返回</el-button>
        </div>
        <!-- <h3>公用部分</h3> -->
        <div class="m-t-20 p-b-10 p-l-10" v-if="type == OPERATION_LIST">
          <div class="ovf-hd">
            <div class="fl">筛选区配置</div>
            <div class="fl m-l-20">
              <el-button size="small" type="primary" @click="addCondition()">添加条件</el-button>
            </div>
            <div class="fl m-l-20">
              <el-button size="small" type="primary" @click="showCombination()">组合筛选</el-button>
            </div>
          </div>
          <div class="m-t-10">
            <el-table
              :data="allData.filter"
              border
              style="width: 100%"
              :row-class-name="tableRowClassName">
              <el-table-column
                prop="name"
                label="条件名称"
                width="150">
              </el-table-column>
              <el-table-column
                label="样式"
                width="100">
                <template scope="scope">
                  <span>{{ scope.row.type | widget }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="字段">
                <template scope="scope">
                  <div v-if="multipleShow(scope.row.type)">
                    <el-tag v-for="item in scope.row.filter_field" class="m-l-5" type="primary">{{ getFieldName(item) }}</el-tag>
                  </div>
                  <div v-else>
                    <el-tag class="m-l-5" type="primary">{{ getFieldName(scope.row.filter_fields) }}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="180">
                <template scope="scope">
                  <el-button type="text" size="small" @click="setConditionConfig(scope.row, scope.$index)">配置</el-button>
                  <el-button type="text" size="small" v-if="scope.$index !== 0" @click="moveUp(scope.$index)">上移</el-button>
                  <el-button type="text" size="small" v-if="scope.$index !== allData.filter.length -1" @click="moveDown(scope.$index)">下移</el-button>
                  <el-button type="text" size="small" @click="deleteCondition(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <operation-table
            :componentData="allData.common_config.head_handle"
            :private="false"
            :showType="showType"
            :focusIndex="operationFocusIndex"
            :application="allOperation"
            @addOperation="addOperation"
            @deleteOperation="deleteOperation"
            @setOperationConfig="setOperationConfig">
          </operation-table> -->
        </div>
        <div class="m-t-20 p-b-10 bor-b-ccc">
  <!--         <div>
            <el-button type="primary" @click="showAddListDialog()">新增列表</el-button>
          </div> -->
          <div class="design-list-item">
            <!-- <div class="ovf-hd p-l-10">
              <div class="fl">
                <h3>{{ item.name }}</h3>
              </div>
              <div class="fl m-l-20 p-t-15">
                <el-button size="small" type="danger" @click="deleteList(index, item.id)">删除</el-button>
              </div>
            </div> -->
            <!-- 列表 -->
            <div v-if="type == OPERATION_LIST">
              <operation-table
                :componentData="allData.handle"
                :listIndex="index"
                :showType="showType"
                :focusIndex="operationFocusIndex"
                :operationPrivate="operationPrivate"
                :allOperationById="allOperationById"
                @addOperation="addOperation"
                @deleteOperation="deleteOperation"
                @setOperationConfig="setOperationConfig">
              </operation-table>
              <list-table
                :showType="showType"
                :tableData="allData.column"
                :fields="listFields"
                :listIndex="index"
                :focusIndex="listSelectedIndex"
                @addCol="addCol"
                @deleteCol="deleteCol"
                @setColConfig="setColConfig"
                @setSortConfig="setSortConfig">
                <template>
                  <el-button size="small" type="primary" @click="setSelfHandleConfig">自定义</el-button>
                </template>          
              </list-table>
            </div>
            <!-- 图表 -->
            <div v-if="type == OPERATION_CHART">
              <chart-table
                :showType="showType"
                :listIndex="index"
                :focusIndex="listSelectedIndex"
                :chartData="allData"
                @setChartData="setChartData"
                @setChartConfig="setChartConfig">
              </chart-table>
            </div>
          </div>
        </div>
      </div>
      <div class="m-t-20">
        <el-button @click="submit()" :loading="submitLoading">保存配置</el-button>
      </div>
    </div>
    <div class="design-right-config">
      <!--Todo-组合筛选配置-->
      <combination-config
        v-if="showCombinationConfig"
        :combinationData='combinationData'
        :fields='listFields'>
      </combination-config>
      <!---->
      <condition-config
        v-if="showConditionConfig"
        :index="conditionIndex"
        :tables="tables"
        :condition="conditionConfigData"
        :modelId="modelId">
      </condition-config>
      <operation-config
        v-if="showOperationConfig"
        :operationData="operationConfigData"
        :contentId="contentId"
        :private="operationPrivate"
        :application="allOperation">
      </operation-config>
      <column-config
        v-if="showcolConfig"
        :modelId="modelId"
        :listIndex="listSelectedIndex"
        :focusIndex="listFocusIndex"
        :col="colConfigData"
        :fields="listFields"
        :tables="tables">
      </column-config>
      <sort-config
        v-if="showsortConfig"
        :listIndex="listSelectedIndex"
        :listConfigObj="listConfigObj"
        :application="allOperation"
        @changeHandle="changeInnerHandle"
        @changePagination="changePagination">
      </sort-config>
      <self-handle-config
        :fields="listFields"
        :selfHandle="allData.self_handle"
        v-if="showSelfHandleConfig">
      </self-handle-config>
      <chart-config
        v-if="showChartConfig"
        :chart="chartConfigData">
      </chart-config>
    </div>
    <addList
      ref="addList"
      :contentList="contentList"
      :ids="selectedListIds"
      @selectList="addList"
      @selectChart="addChart">
    </addList>
  </div>
</template>
<style>
.design-left-layout {
  float: left;
  width: 750px;
  padding-right: 10px;
  border-right: 1px solid #ccc
}
.content-scroll{
  max-height: 700px;
  overflow-y: scroll;
}
.design-list-item {
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc
}
.design-list-item:last-child {
  padding-bottom: 0px;
  border-bottom: none
}
.design-right-config {
  float: left;
  width: 450px;
  margin-left: 20px;
  max-height: 700px;
  overflow-y: scroll;
}
.el-table .row-focus {
  background: rgba(255, 102, 102, .2)
}
</style>
<script>
  import operationTable from './operationTable'
  import listTable from './listTable'
  import chartTable from './chartTable'
  import addList from './addList'
  import conditionConfig from './conditionConfig'
  import operationConfig from './operationConfig'
  import columnConfig from './colConfig'
  import sortConfig from './sortConfig'
  import chartConfig from './chartConfig'
  import combinationConfig from './combinationConfig.vue'
  import selfHandleConfig from './selfHandleConfig.vue'
  import cmsConfig from '../../../config/cmsConfig'
  import http from '../../../assets/js/http'
  export default {
    name: 'designList',
    data() {
      return {
        conditionIndex: -1,           // 当前focus条件对象在数组中的角标
        operationFocusIndex: -1,      // 当前focus操作配置对象在数组中的角标
        listSelectedIndex: -1,        // 当前正在配置的列表在所有数据中的位置角标
        listFocusIndex: -1,           // 当前正在配置的列在当前列表中的角标
        listPagination: null,         // 分页配置
        loading: true,
        submitLoading: false,
        operationPrivate: true,
        contentId: null,
        dealId: null,
        showType: null,
        conditionObj: {
          is_visible: 0,
          is_multiple: 0,
          is_code: 0,
          logic: '=',
          field_id: '',
          name: '',
          type: null,
          param: '',
          table: {
            id: null,
            name: ''
          },
          default: '',
          filter_fields: [],
          forbidden_option: [],
          key_condition: '',
          show_name: '',  // 外键下拉框的显示名
          show_type: 10, // 是否高级筛选
          fields: [],
          free_rule: {  // 无视本条件的权限
            id: null,
            name: ''
          }
        },
        listConfigObj: {},
        listObj: {
          // id: null,
          // modelId: null,
          fields: [],
          column: [], // 列配置
          field_name: [], // 数据排序配置
          filter: [], // 头部筛选配置
          handle: [], // 头部操作
          inner_handle: [], // 行内操作
          is_serial: 0, // 是否显示序号
          pagination: null,  // 分页配置
          data_sort: [],
          filter_build: { // 组合筛选数据
            build_auth: '',
            use_auth: '',
            filter_field_ids: [],
            is_open: 0,
            select_map: []
          },
          self_handle: [] // 操作区自定义
        },
        chartObj: {
          // id: null,
          // modelId: null,
          // type: null,
          // name: '',
          fields: [],
          chartType: null
        },
        modelId: -1,
        conditionConfigData: {},
        operationConfigData: {},
        colConfigData: {},
        chartConfigData: {},
        sortData: [],
        listInnerHandleIds: [],
        combinationData: { // 组合筛选数据
          build_auth: '',
          use_auth: '',
          filter_field_ids: [],
          is_open: 0,
          select_map: []
        }, // 组合筛选数据
        combinationFields: [], // 组合筛选字段
        allData: {},
        listFields: [],
        tables: [],   // 筛选区设置的关联数据表
        selectedListIds: [],
        contentList: [],
        allOperation: [],
        allOperationById: {},
        type: ''
      }
    },
    methods: {
      async addChart(item) {
        this.selectedListIds.push(item.id)
        let newlistObj = _.cloneDeep(this.chartObj)
        // newlistObj.modelId = item.model_id
        // newlistObj.id = item.id
        // newlistObj.name = item.name
        // newlistObj.type = item.type
        this.type = item.type
        // newlistObj.fields = await this.getListFields(item.model_id)
        this.allData = newlistObj
        // this.allData.list_config.push(newlistObj)
      },
      addCol(listIndex, obj) {
        this.allData.column.push(obj)
      },
      addCondition() {
        let newCondition = _.cloneDeep(this.conditionObj)
        this.allData.filter.push(newCondition)
        // this.allData.common_config.filter.push(newCondition)
      },
      async addList(item) {
        this.selectedListIds.push(item.id)
        let newlistObj = _.cloneDeep(this.listObj)
        // newlistObj.modelId = item.model_id
        // newlistObj.id = item.id
        // newlistObj.name = item.name
        // newlistObj.type = item.type
        this.type = item.type
        // newlistObj.fields = await this.getListFields(item.model_id)
        this.allData = newlistObj
        // this.allData.list_config.push(newlistObj)
      },
      addOperation(isPrivate, listIndex, obj) {
        if (!isPrivate) {
          this.allData.head_handle.push(obj)
        } else {
          this.allData.handle.push(obj)
        }
      },
      changeInnerHandle(handles, listIndex) {
        this.allData.inner_handle = handles
      },
      changePagination(pagination, listIndex) {
        this.allData.pagination = pagination
      },
      moveUp(index) {
        _g.moveUpOrDown(this.allData.filter, index, index - 1)
      },
      moveDown(index) {
        _g.moveUpOrDown(this.allData.filter, index, index + 1)
      },
      // deleteList(index, id) {
      //   this.$confirm('确定删除此列表？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.allData.list_config.splice(index, 1)
      //     const pos = this.selectedListIds.indexOf(id)
      //     this.selectedListIds.splice(pos, 1)
      //   }).catch(() => {
      //   })
      // },
      deleteCol(listIndex, index) {
        if (index < 0) {
          return
        }
        this.colConfigData = {}
        this.showType = null
        this.allData.column.splice(index, 1)
      },
      deleteCondition(index) {
        this.allData.filter.splice(index, 1)
        this.conditionConfigData = {}
        this.showType = null
      },
      deleteOperation(isPrivate, listIndex, index) {
        this.operationConfigData = {}
        this.showType = null
        this.allData.handle.splice(index, 1)
      },
      goBack() {
        _g.goBack()
      },
      getContentId() {
        return this.$route.params.contentId
      },
      getDealId() {
        return this.$route.params.id
      },
      multipleShow(type) {
        if (type != this.FILTER_SELECT && type != this.FILTER_FOREIGNKEY && type != this.FILTER_CHECKBOX && type != this.FILTER_FOREIGNKEYCHECKBOX) {
          return true
        }
      },
      async getContentList() {
        let query = {
          params: {
            content_id: this.contentId,
            type: '10,130'
          }
        }
        let arr = []
        let res = await this.apiGet('cms/deals', query)
        return this.promiseHandler(arr, res)
      },
      // 获取保存列表操作
      async getListConfig() {
        let obj = {}
        let res = await this.apiGet(`cms/deals/list/${this.contentId}`)
        return this.promiseHandler(obj, res)
      },
      // 获取字段
      async getListFields(id) {
        let arr = []
        let res = await this.apiGet(`cms/deals/fields/${id}`)
        return this.promiseHandler(arr, res)
      },
      async getOperation() {
        const query = {
          params: {
            content_id: this.contentId
          }
        }
        let arr = []
        let res = await this.apiGet(`cms/deals`, query)
        return this.promiseHandler(arr, res)
      },
      async getTables() {
        let arr = []
        let res = await this.apiGet(`form/models`)
        return this.promiseHandler(arr, res)
      },
      async getDetail() {
        let obj = {}
        let res = await this.apiGet(`cms/deals/${this.dealId}`)
        return this.promiseHandler(obj, res)
      },
      async init() {
        this.contentId = this.getContentId()
        this.dealId = this.getDealId()
        this.contentList = await this.getContentList()
        let tableRes = await this.getTables()
        this.tables = tableRes.list
        this.allOperation = await this.getOperation()
        _(this.allOperation).forEach((res) => {
          this.allOperationById[res.id] = res.name
        })
        // let configData = await this.getListConfig()
        this.loading = false
        // this.setAllData(configData)
        // // Todo 组合筛选获取字段列表--
        // let model_id = null
        // if (this.contentList && this.contentList.length > 0) {
        //   _(this.contentList).forEach((res) => {
        //     if (res.type === 10) {
        //       model_id = res.model_id
        //     }
        //   })
        // }
        // if (model_id) {
        //   this.combinationFields = await this.getListFields(model_id)
        //   console.log('this.combinationFields', this.combinationFields)
        // }
        // this.allData.common_config.head_handle = configData.common_config.head_handle
        // this.allData.common_config.filter = configData.common_config.filter
        // this.allData.list_config = configData.list_config
        // _(this.allData.list_config).forEach((res) => {
        //   this.selectedListIds.push(res.id)
        // })
        let detail = await this.getDetail()
        if (!detail.config) {
          _(this.contentList).forEach((res) => {
            if (res.id == this.dealId) {
              this.type = res.type
              if (res.type == this.OPERATION_LIST) {  // 列表
                this.addList(res)
              } else if (res.type == this.OPERATION_CHART) {  // 图表
                this.addChart(res)
              }
              return false
            }
          })
        } else {
          if (_g.isRealEmpty(detail.config.self_handle)) {
            detail.config.self_handle = []
          }
          this.allData = detail.config
          this.type = detail.type
          // this.allData.modelId = detail.model_id
          // this.allData.id = detail.id
          // this.allData.name = detail.name
          // this.allData.type = detail.type
        }
        if (this.type == this.OPERATION_LIST) {
          if (this.allData.filter_build) {
            this.combinationData = this.allData.filter_build
          } else {
            this.allData.filter_build = this.combinationData
          }
        }
        this.modelId = detail.model_id
        this.listFields = await this.getListFields(this.modelId)
        this.allData.fields = this.listFields
      },
      logData() {
        // console.log('data = ', this.allData)
      },
      setOperationConfig(isPrivate, listIndex, index) {
        this.showType = 'operation'
        this.operationPrivate = isPrivate
        if (!isPrivate) {
          this.operationConfigData = this.allData.head_handle[index]
        } else {
          this.operationFocusIndex = listIndex
          this.operationConfigData = this.allData.handle[index]
        }
      },
      setSelfHandleConfig() {
        this.showType = 'selfHandle'
      },
      showAddListDialog() {
        this.$refs.addList.open()
      },
      setChartConfig(listIndex, index) {
        if (index < 0) {
          return
        }
        this.showType = 'chart'
        // this.listSelectedIndex = listIndex
        this.chartConfigData = this.allData
        // console.log('chartConfigData = ', this.chartConfigData)
      },
      setColConfig(listIndex, index) {
        if (index < 0) {
          return
        }
        this.showType = 'col'
        this.listSelectedIndex = listIndex
        this.listFocusIndex = index
        this.colConfigData = this.allData.column[index]
        if (!(this.colConfigData.summaryConfig)) {
          this.$set(this.colConfigData.summaryConfig, 'marjor_field', '')
        }
      },
      setConditionConfig(item, index) {
        this.conditionConfigData = item
        this.showType = 'condition'
        this.conditionIndex = index
      },
      setSortConfig(listIndex, index) {
        if (index < 0) {
          return
        }
        this.showType = 'sort'
        this.listSelectedIndex = listIndex
        this.listConfigObj = this.allData
      },
      setChartData(config) {
        _(config).forEach((res, key) => {
          this.$set(this.allData, key, res)
        })
        // this.allData = config
      },
      submit() {
        this.submitLoading = !this.submitLoading
        // 检查组合筛选字段是否为空
        if (this.type == this.OPERATION_LIST) {
          if (this.allData.filter_build.is_open === 1) {
            if (this.allData.filter_build.filter_field_ids.length === 0) {
              _g.toastMsg(this, 'error', '组合筛选功能缺少字段选择')
              this.submitLoading = !this.submitLoading
              return
            }
          }
        }
        let config = _.cloneDeep(this.allData)
        _(config.filter).forEach((res) => {
          res.fields = []
        })
        _(config.column).forEach((res) => {
          res.field_option = []
          if (res.summaryConfig) {
            res.summaryConfig.field_option = []
            res.summaryConfig.foreign_option = []
          }
          if (res.statistics_configs) {
            res.statistics_configs.field_option = []
            res.statistics_configs.foreign_option = []
          }
          if (res.link_option) {
            _(res.link_option).forEach((item) => {
              item.field_option = []
            })
          }
        })
        let row_stylesheet = config.row_stylesheet
        config.row_stylesheet = []
        _(row_stylesheet).forEach((res) => {
          if (!(res.field_id == '' && res.logic == '' && res.stylesheet == '' && res.type == '' && res.value == '')) {
            res.stylesheet = parseInt(res.stylesheet)
            config.row_stylesheet.push(res)
          }
        })
        config.fields = []
        let postData = {
          config: config
        }
        this.apiPut(`cms/deals/${this.dealId}`, '', postData).then((res) => {
          this.submitLoading = !this.submitLoading
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功')
          } else {
            _g.dealError(this, res)
          }
        })
      },
      // 控制显示组合筛选
      showCombination() {
        this.showType = 'combination'
      },
      tableRowClassName(row, index) {
        let className = ''
        if (this.showType == 'condition' && index == this.conditionIndex) {
          className = 'row-focus'
        }
        return className
      },
      getConfigs() {
        this.apiGet('cms/contents').then((res) => {
          if (res.code == 200) {
            this.configs = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getFieldName(id) {
        let name = ''
        _(this.listFields).forEach((res) => {
          if (res.field_id == id) {
            name = res.field
            return false
          }
        })
        return name
      }
    },
    created() {
      this.init()
      this.getConfigs()
    },
    computed: {
      showConditionConfig() {
        return this.showType == 'condition' && this.allData.filter.length
      },
      showOperationConfig() {
        let show = false
        if (this.showType == 'operation') {
          // if (this.allData.head_handle.length) {
          //   show = true
          // }
          if (this.allData.handle && this.allData.handle.length) {
            show = true
          }
        }
        return show
      },
      showcolConfig() {
        let show = false
        if (this.showType == 'col' && this.allData.column && this.allData.column.length) {
          show = true
        }
        return show
      },
      showsortConfig() {
        return this.showType == 'sort' && this.allData
      },
      showChartConfig() {
        return this.showType == 'chart'
      },
      // Todo 计算配置组合筛选数据
      showCombinationConfig() {
        return this.showType === 'combination'
      },
      showSelfHandleConfig() {
        return this.showType === 'selfHandle'
      }
    },
    components: {
      operationTable,
      listTable,
      chartTable,
      addList,
      conditionConfig,
      operationConfig,
      columnConfig,
      sortConfig,
      chartConfig,
      combinationConfig,
      selfHandleConfig
    },
    mixins: [http, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// designList.vue?6d6f52c4